import React, {useState} from 'react';
import {getProfile, goMainRoute} from '../../helpers/auth';
import {setLocalSession} from '../../services/authService';
import '../../views/login/login.sass';
import LoginForm from '../../views/login/loginForm';
import * as Yup from 'yup';
import useStore from '../../hooks/use-store';
import useServices from "../../hooks/use-services";
import usePayProvider from "../../hooks/use-pay-provider";

const LoginContainer = () => {

    const {store} = useStore();
    const {deviceService, positionService} = useServices();
    const {syncExternalApi} = usePayProvider();
    const {auth, devices, setSession, azulPayStore, fullControlStore} = store;

    const schema = Yup.object().shape({
        email: Yup.string()
            .email('O e-mail é inválido')
            .required('O e-mail é requerido'),
        password: Yup.string()
            .min(4)
            .required('A senha é requerida'),
    });

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const clear = () => {
        setError(false);
    };

    const submitLogin = async (data) => {
        setError(false);
        setLoading(true);
        try {
            const session = await auth.signIn(data);
            auth.setAuthInfo(data.email, data.password);

            setSession(session);
            setLocalSession(auth.token);

            const positions = await positionService.list(data);
            const devicesData = await deviceService.list();

            devices.addAll(devicesData);
            devices.updatePositions(positions);

            await syncExternalApi();

            // if (session.attributes && session.attributes.hasOwnProperty('payment_provider')) {
            //     const paymentProvider = session.attributes.payment_provider;
            //
            //     if(paymentProvider.toUpperCase() === 'FULL_CONTROL'){
            //
            //         if(session.attributes.full_control_client_id && session.attributes.full_control_secret_id){
            //
            //             fullControlStore.setClientId(session.attributes.full_control_client_id);
            //             fullControlStore.setSecretId(session.attributes.full_control_secret_id);
            //             await fullControlStore.loadClients();
            //             await fullControlStore.loadEquipments();
            //         }
            //     }
            // } else {
            //     if (session.attributes && session.attributes.hasOwnProperty('apiKeySeller')) {
            //         await azulPayStore.setApiKeySelle(session.attributes.apiKeySeller);
            //         await azulPayStore.loadCustomers();
            //     }
            // }

            auth.setProfile(
                getProfile({...session, devicesLength: devicesData.length, auth: data}),
            );

            auth.setLogged(true);
            setLoading(false);
            goMainRoute(auth.profile);
        } catch (e) {
            console.log(e);
            setLoading(false);
            setError(true);
        }
    };

    return <LoginForm
              loading={loading}
              schema={schema}
              onLogin={submitLogin}
              error={error}
              clear={clear}
           />;
};


export default LoginContainer;
